// extracted by mini-css-extract-plugin
module.exports = {"Cell":"Cell__2YHXj"};